import { OperatorId } from '@entities/operator';
import { type ProviderOfferData, type ProviderOffer } from '../model/types';

const TRAVELATA_PIN_POSITION = 2;

const pinTravelata = (providers: ProviderOfferData[], travelata: ProviderOfferData): void => {
  const travelataIndex = providers.indexOf(travelata);
  if (travelataIndex > TRAVELATA_PIN_POSITION) {
    providers.splice(travelataIndex, 1);
    providers.splice(TRAVELATA_PIN_POSITION, 0, travelata);
  }
};

const buildRoomProviders = (offers: ProviderOffer[]): ProviderOfferData[] => {
  if (offers.length === 0) return [];

  const cheapestByOperator = new Map<number, ProviderOfferData>();
  let minPrice = offers[0].price;

  offers.forEach((offer) => {
    minPrice = Math.min(minPrice, offer.price);

    const current = cheapestByOperator.get(offer.operatorId);
    if (current && current.price <= offer.price) return;

    cheapestByOperator.set(offer.operatorId, {
      operatorId: offer.operatorId,
      name: offer.operatorName,
      price: offer.price,
      isLowestPrice: false,
      redirectUrl: offer.bookingUrl,
    });
  });

  const providers = [...cheapestByOperator.values()];
  const travelataHotelOffer =
    cheapestByOperator.get(OperatorId.Travelata[0]) ?? cheapestByOperator.get(OperatorId.Travelata[1]) ?? null;

  if (travelataHotelOffer && travelataHotelOffer.price === minPrice) {
    travelataHotelOffer.isLowestPrice = true;
  }

  providers.sort((a, b) => a.price - b.price);

  if (travelataHotelOffer && providers.length > TRAVELATA_PIN_POSITION + 1) {
    pinTravelata(providers, travelataHotelOffer);
  }

  return providers;
};

export default buildRoomProviders;
